export default __webpack_public_path__ + "img/c41dd884c678ba24867675964e603731.png";